module.exports = __webpack_public_path__ + "6441281a5df3507e6d97ae8f7530e365.svg";